import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import CompanyListForm from '@src/features/tenant/company/CompanyListForm';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CompanyList() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <CompanyListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CompanyList;
